import { render, staticRenderFns } from "./VoiceDoing.vue?vue&type=template&id=4268767c&scoped=true"
import script from "./VoiceDoing.vue?vue&type=script&lang=js"
export * from "./VoiceDoing.vue?vue&type=script&lang=js"
import style0 from "./VoiceDoing.vue?vue&type=style&index=0&id=4268767c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4268767c",
  null
  
)

export default component.exports